import * as React from "react";
import type { SVGProps } from "react";
const SvgSmallClock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <circle
      cx={8}
      cy={8.002}
      r={6.003}
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.304 8.77 8 8.001V4"
    />
  </svg>
);
export default SvgSmallClock;
